import React from "react";
import { TextField, IconButton, InputAdornment, SendIcon } from "app/material-framework/materialComponents";
import { useTheme } from "@mui/material/styles";

export function ChatbotInput({ value, onChange, onSend, onKeyDown, disabled }) {
  const theme = useTheme();

  return (
    <TextField
      fullWidth
      variant="outlined"
      size="small"
      placeholder="Type your message..."
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      disabled={disabled}
      InputProps={{
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000E0",
          borderRadius: 16,
        },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => onSend()}
              disabled={!value.trim() || disabled}
              sx={{ color: theme.palette.primary.main }}
              aria-label="send"
            >
              <SendIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
